import { ProductsActionTypes } from "./constants";

const INIT_STATE = {
  list: [],
  total: 0,
  one: null,
  loading: false,
  productCreated: true, // true = new product, false = stock added to existing
};

interface ProductCreate {
  country: string;
  affiliate: string;
  name: string;
  price: number;
  description: string;
  quantity: number;
  comment: string;
  productImage: string;
}

interface ProductsData {
  items?: any[];
  total?: number;
}

interface GetProductsData {
  id: string;
}

interface ProductsActionType {
  type:
    | ProductsActionTypes.GET_LIST_PRODUCTS
    | ProductsActionTypes.GET_LIST_PRODUCTS_ERROR
    | ProductsActionTypes.GET_LIST_PRODUCTS_SUCCESS
    | ProductsActionTypes.CREATE_PRODUCT
    | ProductsActionTypes.CREATE_PRODUCT_SUCCESS
    | ProductsActionTypes.CREATE_PRODUCT_ERROR
    | ProductsActionTypes.GET_PRODUCT
    | ProductsActionTypes.GET_PRODUCT_SUCCESS
    | ProductsActionTypes.GET_PRODUCT_ERROR
    | ProductsActionTypes.UPDATE_PRODUCT
    | ProductsActionTypes.UPDATE_PRODUCT_SUCCESS
    | ProductsActionTypes.UPDATE_PRODUCT_ERROR
    | ProductsActionTypes.DELETE_PRODUCT
    | ProductsActionTypes.DELETE_PRODUCT_SUCCESS
    | ProductsActionTypes.DELETE_PRODUCT_ERROR;
  payload: {
    actionType?: string;
    data?: ProductsData;
    createData?: ProductCreate;
    getProduct?: GetProductsData;
    error?: string;
    productCreateError?: string;
    updated: false;
    refreshList: false;
  };
}

interface State {
  list?: any[];
  total?: number;
  one?: any;
  loading?: boolean;
  value?: boolean;
}

const Products = (
  state: State = INIT_STATE,
  action: ProductsActionType
): any => {
  switch (action.type) {
    case ProductsActionTypes.GET_PRODUCT:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        productCreateError: "",
        total: 0,
        updated: false,
      };
    case ProductsActionTypes.GET_PRODUCT_SUCCESS:
      switch (action.payload.actionType) {
        case ProductsActionTypes.GET_PRODUCT: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            productCreateError: "",
            updated: false,
          };
        }
        default:
          return { ...state };
      }

    case ProductsActionTypes.GET_PRODUCT_ERROR:
      switch (action.payload.actionType) {
        case ProductsActionTypes.GET_PRODUCT: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            productCreateError: action.payload.error,
            updated: false,
          };
        }
        default:
          return { ...state };
      }

    case ProductsActionTypes.CREATE_PRODUCT:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        productCreateError: "",
        total: 0,
      };
    case ProductsActionTypes.CREATE_PRODUCT_SUCCESS:
      switch (action.payload.actionType) {
        case ProductsActionTypes.CREATE_PRODUCT: {
          const data = action.payload.data as { product?: any; created?: boolean } | any;
          const product = data?.product ?? data;
          const created = data?.created !== false;
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: product,
            productCreated: created,
            error: "",
            productCreateError: "",
          };
        }
        default:
          return { ...state };
      }

    case ProductsActionTypes.CREATE_PRODUCT_ERROR:
      switch (action.payload.actionType) {
        case ProductsActionTypes.CREATE_PRODUCT: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            productCreateError: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case ProductsActionTypes.UPDATE_PRODUCT:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        productCreateError: "",
        total: 0,
      };
    case ProductsActionTypes.UPDATE_PRODUCT_SUCCESS:
      switch (action.payload.actionType) {
        case ProductsActionTypes.UPDATE_PRODUCT: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            productCreateError: "",
            updated: true,
          };
        }
        default:
          return { ...state };
      }

    case ProductsActionTypes.UPDATE_PRODUCT_ERROR:
      switch (action.payload.actionType) {
        case ProductsActionTypes.UPDATE_PRODUCT: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            productCreateError: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case ProductsActionTypes.GET_LIST_PRODUCTS_SUCCESS:
      switch (action.payload.actionType) {
        case ProductsActionTypes.GET_LIST_PRODUCTS: {
          return {
            ...state,
            list: action.payload.data.items,
            loading: false,
            total: action.payload.data.total,
            one: null,
            error: "",
            productCreateError: "",
            updated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case ProductsActionTypes.GET_LIST_PRODUCTS_ERROR:
      switch (action.payload.actionType) {
        case ProductsActionTypes.GET_LIST_PRODUCTS: {
          // Voir Orders: on garde list/total pour ne pas vider l'écran sur
          // un 401 pendant refresh token / blip réseau.
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            updated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case ProductsActionTypes.GET_LIST_PRODUCTS:
      // Idem : on garde list/total le temps du refetch pour éviter le flash
      // "aucun produit" pendant un simple changement de filtre.
      return {
        ...state,
        loading: true,
        one: null,
        error: "",
        productCreateError: "",
        updated: false,
        refreshList: false,
      };
    case ProductsActionTypes.DELETE_PRODUCT:
      return {
        ...state,
        refreshList: false,
      };
    case ProductsActionTypes.DELETE_PRODUCT_SUCCESS:
      switch (action.payload.actionType) {
        case ProductsActionTypes.DELETE_PRODUCT: {
          return {
            ...state,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case ProductsActionTypes.DELETE_PRODUCT_ERROR:
      switch (action.payload.actionType) {
        case ProductsActionTypes.DELETE_PRODUCT: {
          return {
            ...state,
            error: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }
    default:
      return { ...state };
  }
};

export default Products;
